export default {
    users: [],
    pagination: {
        page: 1,
        rowsPerPage: 10
    },
    totalItems: 0
}
